import { Tooltip, Button } from "antd";
import { ReactElement } from "react";

interface ICrudTableProcessButtonProps {
  tooltipText?: string;
  icon: ReactElement;
  onClick: any;
  disabled?: boolean;
  marginRight?: string;
}

const CrudTableProcessButton = (props: ICrudTableProcessButtonProps) => {
  return (
    <Tooltip title={props.tooltipText}>
      <Button
        disabled={props.disabled}
        style={{ marginRight: props.marginRight ?? "1em" }}
        onClick={props.onClick}
        shape="circle"
        icon={props.icon}
      />
    </Tooltip>
  );
};

export default CrudTableProcessButton;
